export default __webpack_public_path__ + "astern/fonts/Oswald-Medium.d16e8751a30f80d546e9d1c4bd07823b.ttf";